import React from 'react';

import FormControl from '@mui/material/FormControl';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import TransitionsModal from '../../component/TransitionsModal';

const ShowOpenedServiceRequest = ({ open, srToShow, handleCloseRs }) => {

    if (!srToShow) return null;

    return(

        <TransitionsModal
            title={`SS Aberta`}
            open={open}
        >

            <Box sx={{bgcolor: 'background.paper'}}>

                <FormControl fullWidth sx={{padding: 1}}>

                    <Box>

                        <Grid container sx={{border: 1, padding: 0.5, mb: 1, borderRadius: 1, borderColor: 'primary.card'}}>
                            <Grid item xs={12} sm={12}>{`SS: ${srToShow.number}`}</Grid>
                            <Grid item xs={12} sm={12}>{`Status: ${srToShow.status}`}</Grid>

                            {
                                !srToShow.performer ? null :
                                <Grid item xs={12} sm={12}>{`Executante: ${srToShow.performer}`}</Grid>
                            }

                            <Grid item xs={12} sm={12}>{`Dt Abertura: ${srToShow.openingDate}`}</Grid>
                            <Grid item xs={12} sm={12}>{`Serviço: ${srToShow.serviceType}`}</Grid>
                            <Grid item xs={12} sm={12}>{`Bem: ${srToShow.asset}`}</Grid>
                            <Grid item xs={12} sm={12}>{`Centro de custo: ${srToShow.department}`}</Grid>
                        </Grid>

                        <Grid container sx={{border: 1, padding: 0.5, mb: 1, borderRadius: 1, borderColor: 'primary.card'}}>
                            <Grid item xs={12} sm={12}>{`Solicitação:`}</Grid>
                            <Grid item xs={12} sm={12}>{`${srToShow.request}`}</Grid>
                        </Grid>

                        <Grid container sx={{border: 1, padding: 0.5, mb: 1, borderRadius: 1, borderColor: 'primary.card'}}>
                            <Grid item xs={12} sm={12}>{`Máquina parada: ${srToShow.maquinaParada === '1' ? 'Sim' : 'Não'}`}</Grid>
                            <Grid item xs={12} sm={12}>{`Data início da parada: ${srToShow.dtIniParada}`}</Grid>
                            <Grid item xs={12} sm={12}>{`Hora início da parada: ${srToShow.hrIniParada}`}</Grid>
                            <Grid item xs={12} sm={12}>{`Data fim da parada: ${srToShow.dtFimParada}`}</Grid>
                            <Grid item xs={12} sm={12}>{`Hora fim da parada: ${srToShow.hrFimParada}`}</Grid>
                        </Grid>

                    </Box>

                    <ButtonGroup
                        sx={{display: 'flex', width: '100%', justifyContent: 'flex-end', mt: 1}}
                        disableElevation
                    >

                        <Button variant='contained' color='error' onClick={handleCloseRs}>
                            Fechar
                        </Button>

                    </ButtonGroup>

                </FormControl>

            </Box>

      </TransitionsModal>

    );

};

export default ShowOpenedServiceRequest;